import React from "react";

interface PainelColunaProps {
  title: string;
  count: number;
  icon: React.ReactNode;
  mediaText?: string | null;
  showTempoMedio?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const PainelColunaInner: React.FC<PainelColunaProps> = (props) => {
  const {
    title,
    count,
    icon,
    mediaText,
    showTempoMedio = true,
    children,
    footer,
    className = "",
  } = props;
  return (
    <div
      className={
        "flex min-h-0 min-w-[260px] flex-1 flex-col rounded-lg border border-neutral-200 bg-neutral-50/80 shadow-sm " +
        className
      }
    >
      <div className="flex shrink-0 items-center gap-2 border-b border-neutral-200 bg-white px-4 py-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
          {icon}
        </span>
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-sm font-bold uppercase tracking-wide text-neutral-600">
            {title}
          </h3>
          <p className="text-2xl font-black text-neutral-800">{count}</p>
          {showTempoMedio && (
            <p className="mt-1 text-right text-sm font-semibold text-neutral-700">
              Tempo médio:{" "}
              {mediaText != null && mediaText !== "" ? mediaText : "—"}
            </p>
          )}
        </div>
      </div>
      <div className="min-h-0 flex-1 space-y-2 overflow-y-auto overflow-x-hidden p-3">
        {children}
      </div>
      {footer != null ? (
        <div className="shrink-0 border-t border-neutral-200 bg-white p-2">
          {footer}
        </div>
      ) : null}
    </div>
  );
};

export const PainelColuna = React.memo(PainelColunaInner);
